module.exports = __webpack_public_path__ + "img/empty-resume-base.87e06cad.svg";